import UserEventContextValueProvider from "../../App/Compositions/UserEventContextValueProvider";
import NextButtonMobile from "../Components/NextButtonMobile";

/** A value provider which provisions user event context values to the {@link NextButtonMobile}. */
const UserEventNextButtonMobile = UserEventContextValueProvider({ Component: NextButtonMobile });

export default UserEventNextButtonMobile;
